<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="pointer" @contextmenu.prevent="onShowContextMenu($event)" @click="onSidebarInteractionClick()">
    <v-list-item
      class="interaction-item"
      :class="{
        blink: shouldBlink
      }"
    >
      <v-list-item-avatar style="overflow: visible">
        <EcsInteractionAvatar :interaction="interaction" :size="40" />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class="interaction-title">
          <div class="interaction-icon">
            <v-icon v-if="interaction.isIncomingTelephony">mdi-phone-incoming</v-icon>
            <v-icon v-if="interaction.isInternalCall">mdi-card-account-phone</v-icon>
            <v-icon v-if="interaction.isExternalCall">mdi-phone-outgoing</v-icon>
            <v-icon v-if="interaction.isCallback">mdi-phone-return</v-icon>
          </div>
          {{ displayName }}
        </v-list-item-title>
        <v-list-item-subtitle class="interaction-sub-title">
          <span v-if="interaction.isHistoric">{{ timeAgo }}</span>
          <span v-else>{{ activeCallDuration }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action class="flip-container">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon :style="{ color: interactionStatus.color }" v-on="on">
              {{ interactionStatus.icon }}
            </v-icon>
          </template>
          <span>{{ $t(interactionStatus.statusName) }}</span>
        </v-tooltip>
      </v-list-item-action>
    </v-list-item>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import EcsSideBarInteractionItemMixin from '@/mixins/ecs-side-bar-interaction-mixins/EcsSideBarInteractionItemMixin';
import EcsInteractionAvatar from '@/components/ecs-base-interaction-components/ecs-avatar/EcsInteractionAvatar';

export default {
  name: 'EcsSideBarTelephonyInteractionItem',

  components: { EcsInteractionAvatar },

  mixins: [EcsSideBarInteractionItemMixin],

  props: {
    interaction: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      callDurationTimer: null,
      callDuration: 0 // Milliseconds
    };
  },

  computed: {
    ...mapGetters('ELEMENTS', ['getElementsForInteraction']),

    displayName() {
      return this.interaction.formattedCustomerFullName || this.interaction.receptor.name;
    },

    mainElement() {
      const elements = this.getElementsForInteraction(this.interaction);
      return elements.length > 0 ? elements[0] : null;
    },

    activeCallDuration() {
      return this.$t('onCallDuration', { duration: moment.utc(this.callDuration).format('HH:mm:ss') });
    },

    interactionStatus() {
      let result;

      if (this.interaction.isHandled) {
        if (this.interaction.timing.answeredWithinGoalTime) {
          result = this.iconMap.answeredWithinGoalTime;
        } else {
          result = this.iconMap.completed;
        }
      } else if (this.mainElement && this.mainElement.isOnHold) {
        result = this.iconMap.onHoldTelephony;
      } else {
        result = this.iconMap[this.interaction.interactionStateId] || this.iconMap.onCall;
      }

      return result;
    }
  },

  watch: {
    mainElement: {
      handler(updatedElement) {
        if (updatedElement && updatedElement.isEnded) {
          clearInterval(this.callDurationTimer);
        } else if (!this.callDurationTimer) {
          this.startCallDurationTimer();
        }
      },
      deep: true
    }
  },

  mounted() {
    this.startCallDurationTimer();
  },

  beforeDestroy() {
    if (this.callDurationTimer) {
      clearInterval(this.callDurationTimer);
    }
  },

  methods: {
    startCallDurationTimer() {
      if (this.interaction.isDirectCall) {
        this.callDurationTimer = setInterval(() => {
          this.callDuration = moment.utc().diff(moment.utc(this.interaction.timing.directCallAnsweredAt));
        }, 1000);
        return;
      }

      if (!this.mainElement) {
        return;
      }

      this.callDurationTimer = setInterval(() => {
        if (!this.mainElement) {
          return clearInterval(this.callDurationTimer);
        }
        this.callDuration = moment.utc().diff(moment.utc(this.mainElement.answeredAt));
      }, 1000);
    }
  }
};
</script>

<style src="./scoped.css" scoped />
